import React from "react"
import Hero from "../../components/Careers/OpenSeat/Hero"
import JobsOpening from "../../components/Careers/OpenSeat/JobsOpening"
import Layout from "../../components/Layout"
import SEO from "../../components/Seo"

const OpenSeat = () => {
  return (
    <Layout>
      <SEO title="Open Seat" />
      <Hero />
      <JobsOpening />
    </Layout>
  )
}

export default OpenSeat
